import FormGrupo from "components/FormGrupo";

const CriarGrupoProduto = () => (
  <div className="card">
    <FormGrupo />
  </div>
);

export default CriarGrupoProduto;
